import {
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import Paper from "@mui/material/Paper";
import html2pdf from "html2pdf.js";
import { useEffect, useRef, useState } from "react";
import * as React from "react";
import { DateRangePicker } from "react-date-range";
import { useHistory } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/layout";
import DatePickerModal from "../DatePickerModal";
import RejectionModal from "../RejectionModal";
import billingService from "../../services/billing";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DecryptData, jsonParser } from "../../helpers/helper";
import { toast } from "react-toastify";
import { printReceipts } from "../../components/print";

const columns = [
  { id: "sr_no", label: "Sr no.", minWidth: 50, sortable: false },
  {
    id: "bookingId",
    label: "BKId",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "name",
    label: "Name",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "phoneNumber",
    label: "Phone Number",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "billingDate",
    label: "Billing Date",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "totalPrice",
    label: "Total Price",
    minWidth: 100,
    sortable: true,
  },
  {
    id: "details",
    label: "Details",
    minWidth: 100,
    sortable: false,
  },
];
interface EyeDataType {
  name: string;
  email?: string; // Optional if not always present
  phone_no?: string; // Optional if not always present
  servicesData: Array<{}>;
  totalPrice: number;
  discountInPercentage: number;
  grandTotal: number;
  discount: number;
  reason?: string;
}
export default function PaymentHistory() {
  const history = useHistory();
  const toggleContainer = useRef<HTMLDivElement | null>(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [sortBy, setSortBy] = useState<string>("");
  const [tableData, setTableData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [userRoleId, setUserRoleId] = useState(0);
  const [eyeData, setEyeData] = useState<EyeDataType>();
  const [selectedDate, setSelectedDate] = useState(null);
  const [isModalOpenDate, setIsModalOpenDate] = useState(false);
  const [disablePrint, setDisablePrint] = useState(false);

  const getDefaultStartDate = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1); // First day of current month
  };

  const getDefaultEndDate = () => {
    return new Date(); // Today
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: getDefaultStartDate(),
    endDate: getDefaultEndDate(),
    key: "selection",
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      const roleId = parsedUser.roleId;
      setUserRoleId(roleId);
    }
  }, []);

  const handleToggleVisibility = (data: any) => {
    setIsVisible((prev) => !prev);
    console.log(data);
    setEyeData(data);
  };

  // pagination
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = React.useState(0);
  const currentPage = 1;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const capitalizeEachWord = (text) => {
    if (!text || typeof text !== "string") return ""; // Handle empty or non-string values
    return text
      .split(" ") // Split the string into an array of words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join the words back into a single string
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const range = [];
  const minRange = Math.max(1, currentPage - 2);
  const maxRange = Math.min(totalPages, currentPage + 2);
  for (let i = minRange; i <= maxRange; i++) {
    range.push(i);
  }
  const indexOfLastItem = (page + 1) * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (event) => {
    const searchesTerm = event.target.value;
    setSearchTerm(searchesTerm);

    if (searchesTerm === "") {
      setFilteredData(tableData);
      return;
    }

    const filtered = tableData.filter((data) => {
      return (
        data.name?.toLowerCase().includes(searchesTerm.toLowerCase()) ||
        data.email?.toLowerCase().includes(searchesTerm.toLowerCase()) ||
        data.phoneNumber?.toLowerCase().includes(searchesTerm.toLowerCase())
      );
    });

    setFilteredData(filtered);
  };

  const fetchBillingData = async () => {
    const staticStartDate = localStorage.getItem("staticStartDatePayment");
    const startDates = JSON.parse(staticStartDate);
    const startDate = new Date(startDates);

    const staticEndDate = localStorage.getItem("staticEndDatePayment");
    const endDates = JSON.parse(staticEndDate);
    const endDate = new Date(endDates);

    const selectionRanges = {
      startDate: startDate, // or just startDate,
      endDate: endDate, // or just endDate,
      key: "selection",
    };

    setSelectionRange(selectionRanges);

    const isSameDate =
      startDate.getDate() === endDate.getDate() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear();

    let formattedDate = "";

    if (isSameDate) {
      formattedDate = startDate.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    } else {
      const sameMonth = startDate.getMonth() === endDate.getMonth();
      const sameYear = startDate.getFullYear() === endDate.getFullYear();

      if (sameMonth && sameYear) {
        formattedDate = `${startDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      } else if (!sameMonth && sameYear) {
        formattedDate = `${startDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      } else {
        formattedDate = `${startDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDate.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      }
    }

    const formatToLocalDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format: "YYYY-MM-DD"
    };

    setSelectedDate(formattedDate);

    const allFilters = {
      startDate: formatToLocalDate(startDate),
      endDate: formatToLocalDate(endDate),
    };

    const resultData = await billingService.filteredData({
      allFilters,
    });
    const decryptedData = await DecryptData(resultData);
    const parsedData = await jsonParser(decryptedData);

    console.log("1", parsedData);

    const bookingData = parsedData.map((data) => {
      return {
        id: data.id,
        name: DecryptData(data.name),
        reason: data.reason ? DecryptData(data.reason) : null,
        services: data.services,
        servicesData: data.servicesData,
        totalPrice: DecryptData(data.totalPrice),
        bookingId: data.bookingId,
        billingDate: data.billingDate,
        email: data.email ? DecryptData(data.email) : "",
        phone_no: data.phone_no ? DecryptData(data.phone_no) : "",
        discount: data.discount ? DecryptData(data.discount) : 0,
        grandTotal: DecryptData(data.totalPrice),
      };
    });
    const enhancedBillingData = bookingData.map((data) => ({
      ...data,
      phone_no: data?.phone_no ? data.phone_no.replace(/^92/, "0") : "",
    }));
    setFilteredData(enhancedBillingData);
    setTableData(enhancedBillingData);
  };
  useEffect(() => {
    fetchBillingData();
  }, []);

  const handleSort = (columnId: string) => {
    if (columnId === "sr_no" || columnId === "details") return; // Skip sorting for these columns
    if (sortBy === columnId) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(columnId);
      setSortOrder("asc");
    }
  };

  const sortedItems = [...currentItems].sort((a, b) => {
    if (sortBy === "sr_no" || sortBy === "details") return 0; // Skip sorting for these columns
    // Handle date sorting
    if (sortBy === "fromDate") {
      const dateA = new Date(a.fromDate);
      const dateB = new Date(b.fromDate);

      return sortOrder === "asc"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    }
    if (sortBy === "to_date") {
      const dateA = new Date(a.to_date);
      const dateB = new Date(b.to_date);

      return sortOrder === "asc"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    }

    if (a[sortBy] < b[sortBy]) return sortOrder === "asc" ? -1 : 1;
    if (a[sortBy] > b[sortBy]) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  const handleClickOutside = (event: MouseEvent) => {
    if (
      toggleContainer.current &&
      !toggleContainer.current.contains(event.target as Node)
    ) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentId(null);
  };

  const closeModalWithDelete = async () => {
    await billingService.delete(currentId);
    fetchBillingData();
    setIsModalOpen(false);
    setCurrentId(null);
  };

  const handleEditService = async (id) => {
    history.push(`/booking/edit/${id}`);
  };

  const handleDeleteService = async (id) => {
    setIsModalOpen(true);
    setCurrentId(id);
  };

  function handleDownloadPdf() {
    const table = document.getElementById("your-table-id");

    if (table) {
      const container = document.createElement("div");
      container.style.width = "190mm";
      container.style.padding = "10mm";
      const header = document.createElement("div");
      header.innerHTML = `
      <img src="/logo.png" style="display: block; margin: 0 auto; max-width: 180mm; width: 100%; height: auto;" />
    `;
      container.appendChild(header);

      const beforeTable = document.createElement("div");
      beforeTable.innerHTML = '<p style="text-align: center;"></p>';
      container.appendChild(beforeTable);

      const clonedTable = table.cloneNode(true) as HTMLElement;

      const rows = clonedTable.querySelectorAll("tr");
      rows.forEach((row) => {
        const lastCell = row.lastElementChild;
        lastCell?.remove();
      });

      container.appendChild(clonedTable);

      const afterTable = document.createElement("div");
      afterTable.innerHTML =
        '<div style="margin-top:5%;display:flex;flex-direction:row;justify-content:space-around;border-top:1px solid black"><div style="width:30%"><p style="color:#444444">2nd Floor, Plaza 147, Central Commercial, Bahria Orchard, Lahore, 55150, Pakistan</p></div><div><p style="color:#444444">elegancemakeupstudioo@gmail.com</p></div><div><p style="color:#444444">+92 331 555 5933</p></div></div>';
      container.appendChild(afterTable);

      const footer = document.createElement("div");
      footer.innerHTML = '<p style="height:20px"><br></p>';
      container.appendChild(footer);

      // Set CSS styles to avoid content overlap
      const style = document.createElement("style");
      style.innerHTML = `
          .page-break {
            page-break-before: always;
          }
          .container {
            margin-bottom: 50px;
            width: 100%;
            box-sizing: border-box;
          } 
          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed; /* Prevents overflow */
          }
          td, th {
            word-wrap: break-word;
            font-size: 10px; /* Optional: reduce font size for better fit */
          }
          tr {
            page-break-inside: avoid;
          }
        `;
      container.appendChild(style);

      // Add a page break to avoid overlap
      const pageBreak = document.createElement("div");
      pageBreak.className = "page-break";
      container.appendChild(pageBreak);

      const htmlString = container.innerHTML;

      html2pdf()
        .from(htmlString)
        .set({
          margin: 10,
          filename: "user.pdf",
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .save();
    }
  }

  const generateHtmlReceipt = (data) => `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Receipt</title>
    </head>
    <body style="font-family: Arial, sans-serif; max-width: 750px; margin: 0 auto; padding: 20px; background-color: #f9f9f9;">
      <div style="text-align: center; margin-bottom: 20px;">
        <img src="./logo.png" alt="Company Logo" style="width: 200px; height: auto;">
      </div>
      <h2 style="text-align: center; color: #333;">Elegance Beauty Salon Receipt</h2>
      <hr style="border: 1px solid #ccc;">
      
      <!-- Customer Name and Email -->
      <div style="display: flex; justify-content: space-between; margin: 10px 0;">
        <p style="margin: 0;"><strong>Name:</strong> ${data.customerName}</p>
        <p style="margin: 0;"><strong>Phone:</strong> ${
          data.phoneNumber ? data.phoneNumber : "--"
        }</p>
      </div>
      
      <!-- Date and Phone Number -->
      <div style="display: flex; justify-content: space-between; margin: 10px 0;">
        <p style="margin: 0;"><strong>Date:</strong> ${new Date().toLocaleString()}</p>
      </div>
      
      <hr style="border: 1px solid #ccc;">
      <h3 style="color: #333;">Services:</h3>
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th style="text-align: left; color: #333; padding: 8px;">Service Name</th>
            <th style="text-align: right; color: #333; padding: 8px;">Price</th>
            <th style="text-align: right; color: #333; padding: 8px;">Qunatity</th>
            <th style="text-align: right; color: #333; padding: 8px;">Discount</th>
            <th style="text-align: right; color: #333; padding: 8px;">Total</th>
          </tr>
        </thead>
        <tbody>
         ${data.servicesData
           .map(
             (service) => `
                <tr>
                  <td style="color: #555; padding: 8px;">${DecryptData(
                    service.serviceName
                  )}</td>
                  <td style="color: #333; text-align:right; padding: 8px;">${DecryptData(
                    service.servicePrice
                  )}</td>
                  <td style="color: #333; text-align:right; padding: 8px;">${DecryptData(
                    service.quantity
                  )}</td>
                  <td style="color: #333; text-align:right; padding: 8px;">${DecryptData(
                    service.discount
                  )}</td>
                  <td style="color: #333; text-align:right; padding: 8px;">${DecryptData(
                    service.total
                  )}</td>
                </tr>

                ${(service.relatedServices || [])
                  .map(
                    (rs) => `
                <tr>
                  <td style="color: #555; padding: 4px 8px 4px 24px;"> ${DecryptData(
                    rs.serviceName
                  )}</td>
                    <td style="color: #333; text-align:right; padding: 4px 8px;">${DecryptData(
                      rs.servicePrice
                    )}</td>
                  <td style="color: #333; text-align:right; padding: 4px 8px;"></td>
                  <td style="color: #333; text-align:right; padding: 4px 8px;"></td>
                  <td style="color: #333; text-align:right; padding: 4px 8px;"></td>

                </tr>
                `
                  )
                  .join("")}
                `
           )
           .join("")}
        </tbody>
      </table>
      <hr style="border: 1px solid #ccc;">
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th style="text-align: left; color: #333; padding: 8px;">Total Price</th>
            <th style="text-align: right; color: #333; padding: 8px;">${
              data.totalPrice
            }</th>
          </tr>
          <tr>
            <th style="text-align: left; color: #333; padding: 8px;">Total Discount</th>
            <th style="text-align: right; color: #333; padding: 8px;">${
              data.discount
            }%</th>
          </tr>
          <tr>
            <th style="text-align: left; color: #333; padding: 8px;">Grand Total</th>
            <th style="text-align: right; color: #333; padding: 8px;">${
              data.grandTotal
            }</th>
          </tr>
           
          
        </thead>
      </table>
      <hr style="border: 1px solid #ccc;">
      <p style="text-align: center; color: #777;">Thank You!</p>
    </body>
    </html>
        `;

  const onPrint = async (record) => {
    // setDisablePrint(true);

    console.log("onPrint", record);

    // setIsSubmitting(true);
    try {
      const services = record.servicesData.map((data) => {
        const quantity = Number(DecryptData(data.quantity)) || 1;
        const discount = Number(DecryptData(data.discount)) || 0;
        const total = Number(DecryptData(data.total)) || 0;

        // Tax-inclusive calculation
        const base = total / 1.08;
        const tax = total - base;

        return {
          serviceName: DecryptData(data.serviceName),
          quantity,
          discount,
          total,
          base: base.toFixed(2),
          tax: tax.toFixed(2),
        };
      });

      // Calculate totals
      const subtotal = services.reduce((acc, s) => acc + Number(s.base), 0);
      const praTax = services.reduce((acc, s) => acc + Number(s.tax), 0);
      const totalPrice = services.reduce((acc, s) => acc + Number(s.total), 0);

      // const payload = {
      //   customerName: record.name,
      //   cashierName: null,
      //   services: services,
      //   reason: record.reason,
      //   subtotal: record.totalPrice,
      //   praTax: record.totalPrice,
      //   totalPrice: record.totalPrice,
      //   GrandTotal: record.totalPrice,
      //   discountInPercentage: record.totalPrice,
      //   discountInAmount: record.totalPrice,
      // };
      const payload = {
        customerName: record.name,
        cashierName: null,
        services,
        reason: record.reason || "",
        subtotal: subtotal.toFixed(2), // total before tax
        praTax: praTax.toFixed(2), // total tax
        totalPrice: totalPrice.toFixed(2), // total after tax
        GrandTotal: totalPrice.toFixed(2), // total after tax
        discountInPercentage: record.discountInPercentage || 0,
        discountInAmount: record.discountInAmount || 0,

        amountPaid: record.amountPaid || 0, // Maps the paid amount from record, defaults to 0 if missing
        pending: record.pending || 0,
        customReceiptId: "",
      };

      const response = await printReceipts(payload);
      if (response.success === true) {
        toast.success("Print recipt successfully");
      } else {
        toast.success("Printer not found");
      }
    } catch (err) {
      console.error("Error saving data:", err);
      setDisablePrint(false);
    }
  };

  const closeModalDate = () => {
    setIsModalOpenDate(false);
    const sidebar = document.querySelector(".sidebarParent");
    const navbar = document.querySelector(".main__navbar__right");
    if (sidebar) {
      sidebar.classList.remove("blurred__sidebar");
    }
    if (navbar) {
      navbar.classList.remove("blurred__sidebar");
    }
  };
  const openModalDate = () => {
    setIsModalOpenDate(true);
    const sidebar = document.querySelector(".sidebarParent");
    const navbar = document.querySelector(".main__navbar__right");
    if (sidebar) {
      sidebar.classList.add("blurred__sidebar");
    }
    if (navbar) {
      navbar.classList.add("blurred__sidebar");
    }
  };

  const handleSelect = async (ranges) => {
    setSelectionRange(ranges.selection);
  };
  const staticRanges = [
    {
      label: "Today",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
      isSelected: (range) => {
        const today = new Date();
        return (
          range.startDate.toDateString() === today.toDateString() &&
          range.endDate.toDateString() === today.toDateString()
        );
      },
      key: "today",
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
        endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      }),
      isSelected: (range) => {
        const yesterday = new Date(
          new Date().setDate(new Date().getDate() - 1)
        );
        return (
          range.startDate.toDateString() === yesterday.toDateString() &&
          range.endDate.toDateString() === yesterday.toDateString()
        );
      },
      key: "yesterday",
    },
    {
      label: "This Week",
      range: () => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(now.getDate() - now.getDay()); // Sunday
        const end = new Date(start);
        end.setDate(start.getDate() + 6); // Saturday
        return { startDate: start, endDate: end };
      },
      isSelected: (range) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(now.getDate() - now.getDay());
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        return (
          range.startDate.toDateString() === start.toDateString() &&
          range.endDate.toDateString() === end.toDateString()
        );
      },
      key: "thisWeek",
    },
    {
      label: "Last Week",
      range: () => ({
        startDate: new Date(
          new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
        ),
        endDate: new Date(
          new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
        ),
      }),
      isSelected: (range) => {
        const startOfLastWeek = new Date(
          new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
        );
        return (
          range.startDate.toDateString() === startOfLastWeek.toDateString() &&
          range.endDate.toDateString() ===
            new Date(
              new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
            ).toDateString()
        );
      },
      key: "lastWeek",
    },
    {
      label: "This Month",
      range: () => {
        const start = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        const end = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        return { startDate: start, endDate: end };
      },
      isSelected: (range) => {
        const start = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        const end = new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        );
        return (
          range.startDate.toDateString() === start.toDateString() &&
          range.endDate.toDateString() === end.toDateString()
        );
      },
      key: "thisMonth",
    },
    {
      label: "Last Month",
      range: () => ({
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      }),
      isSelected: (range) => {
        const startOfLastMonth = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        );
        return (
          range.startDate.toDateString() === startOfLastMonth.toDateString() &&
          range.endDate.toDateString() ===
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              0
            ).toDateString()
        );
      },
      key: "lastMonth",
    },
    {
      label: "This Year",
      range: () => ({
        startDate: new Date(new Date().getFullYear(), 0, 1),
        endDate: new Date(new Date().getFullYear(), 11, 31),
      }),
      isSelected: (range) => {
        const startOfYear = new Date(new Date().getFullYear(), 0, 1);
        return (
          range.startDate.toDateString() === startOfYear.toDateString() &&
          range.endDate.toDateString() ===
            new Date(new Date().getFullYear(), 11, 31).toDateString()
        );
      },
      key: "thisYear",
    },
    {
      label: "Last Year",
      range: () => ({
        startDate: new Date(new Date().getFullYear() - 1, 0, 1),
        endDate: new Date(new Date().getFullYear() - 1, 11, 31),
      }),
      isSelected: (range) => {
        const startOfLastYear = new Date(new Date().getFullYear() - 1, 0, 1);
        return (
          range.startDate.toDateString() === startOfLastYear.toDateString() &&
          range.endDate.toDateString() ===
            new Date(new Date().getFullYear() - 1, 11, 31).toDateString()
        );
      },
      key: "lastYear",
    },
  ];
  const handleApply = async () => {
    const startDates = selectionRange.startDate;
    const endDates = selectionRange.endDate;
    const isSameDate =
      startDates.getDate() === endDates.getDate() &&
      startDates.getMonth() === endDates.getMonth() &&
      startDates.getFullYear() === endDates.getFullYear();

    let formattedDate = "";

    if (isSameDate) {
      formattedDate = startDates.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    } else {
      const sameMonth = startDates.getMonth() === endDates.getMonth();
      const sameYear = startDates.getFullYear() === endDates.getFullYear();

      if (sameMonth && sameYear) {
        formattedDate = `${startDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      } else if (!sameMonth && sameYear) {
        formattedDate = `${startDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      } else {
        formattedDate = `${startDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        })} - ${endDates.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })}`;
      }
    }

    setSelectedDate(formattedDate);

    localStorage.setItem("staticStartDatePayment", JSON.stringify(startDates));
    localStorage.setItem("staticEndDatePayment", JSON.stringify(endDates));

    const formatToLocalDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

    const allFilters = {
      startDate: formatToLocalDate(selectionRange.startDate),
      endDate: formatToLocalDate(selectionRange.endDate),
    };

    const resultData = await billingService.filteredData({
      allFilters,
    });
    const decryptedData = await DecryptData(resultData);
    const parsedData = jsonParser(decryptedData);
    const bookingData = parsedData.map((data) => {
      return {
        id: data.id,
        name: DecryptData(data.name),
        comments: DecryptData(data.comments),
        services: data.services,
        totalPrice: DecryptData(data.totalPrice),
        servicesData: data.servicesData,
        billingDate: data.billingDate,
        bookingId: data.bookingId,
        email: DecryptData(data.email),
        phone_no: DecryptData(data.phone_no),
        discount: DecryptData(data.discount),
        grandTotal: DecryptData(data.grandTotal),
      };
    });
    const enhancedBillingData = bookingData.map((data) => ({
      ...data,
      phone_no: data?.phone_no ? data.phone_no.replace(/^92/, "0") : "",
    }));

    if (searchTerm !== "") {
      const filtered = enhancedBillingData.filter((data) =>
        data.full_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(enhancedBillingData);
    }

    setTableData(enhancedBillingData);

    closeModalDate();
  };

  const calculateTotal = (price, quantity, discount) => {
    return (price * quantity - discount).toFixed(2);
  };

  return (
    <Layout>
      <div className="leavesIndex">
        <div className="leavesIndex__header" style={{ paddingBottom: 0 }}>
          <div className="leavesIndex__header_left">
            <h4 className="attendance_overview_heading">Payments</h4>
          </div>
        </div>

        <div className="leavesIndex__header">
          <div className="leavesIndex__header_left">
            <div className="remaingLeavesCounter">
              <div className="remaingLeavesCounterEachAttendance">
                <div
                  className={`searchNameFilterParent ${
                    isFocused ? "searchNameFilterParentFocused" : ""
                  }`}
                  style={{ marginRight: "1vw" }}
                >
                  <FormControl variant="standard">
                    <OutlinedInput
                      onChange={handleChange}
                      value={searchTerm}
                      className="searchNameFilter"
                      placeholder="Name/ Email/ Phone no"
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      endAdornment={
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
              <div className="singleInputFieldFilters">
                <FormControl variant="standard">
                  <OutlinedInput
                    className="searchNameFilter"
                    placeholder="Select Date"
                    onClick={openModalDate}
                    value={selectedDate || ""}
                    readOnly
                  />
                </FormControl>
              </div>
              <div
                className="remaingLeavesCounterEachInventoryButton"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <button
                  onClick={handleDownloadPdf}
                  className="downloadPDFButton downloadPDFButton2"
                >
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>
        <Card className="myLeaves__card" variant="outlined">
          <div>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  id="your-table-id"
                >
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          style={{ textAlign: "center" }}
                        >
                          {column.sortable ? (
                            <TableSortLabel
                              active={sortBy === column.id}
                              direction={
                                sortBy === column.id ? sortOrder : "asc"
                              }
                              onClick={() => handleSort(column.id)}
                            >
                              {column.label}
                            </TableSortLabel>
                          ) : (
                            column.label
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedItems.map((row, index) => {
                      const serialNumber = indexOfFirstItem + index + 1;
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={serialNumber}
                        >
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {serialNumber}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {row["bookingId"]}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {capitalizeEachWord(row["name"])}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {row["email"] ? row["email"] : "--"}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {row["phone_no"] ? row["phone_no"] : "--"}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {row["billingDate"]}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {row["grandTotal"]}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                              }}
                            >
                              {/* view */}
                              <div>
                                <button
                                  style={{
                                    border: "none",
                                    color: "#0066ff",
                                    backgroundColor: "transparent",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleToggleVisibility(row)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                  >
                                    <g data-name="Group 295">
                                      <path
                                        data-name="visibility_FILL0_wght300_GRAD0_opsz24 (1)"
                                        d="M13.003 16.95a4.236 4.236 0 0 0 3.115-1.284 4.248 4.248 0 0 0 1.281-3.117 4.236 4.236 0 0 0-1.284-3.115 4.248 4.248 0 0 0-3.117-1.281 4.236 4.236 0 0 0-3.115 1.284 4.248 4.248 0 0 0-1.281 3.117 4.236 4.236 0 0 0 1.284 3.115 4.248 4.248 0 0 0 3.117 1.281zm0-1.485a2.809 2.809 0 0 1-2.063-.85 2.809 2.809 0 0 1-.85-2.063 2.809 2.809 0 0 1 .85-2.063 2.809 2.809 0 0 1 2.063-.85 2.809 2.809 0 0 1 2.063.85 2.809 2.809 0 0 1 .85 2.063 2.809 2.809 0 0 1-.85 2.063 2.809 2.809 0 0 1-2.065.85zm0 4.639a11.281 11.281 0 0 1-6.231-1.817 13.565 13.565 0 0 1-4.509-4.782 1.9 1.9 0 0 1-.2-.468 1.892 1.892 0 0 1-.062-.484 1.884 1.884 0 0 1 .062-.484 1.9 1.9 0 0 1 .2-.468 13.564 13.564 0 0 1 4.509-4.782 11.281 11.281 0 0 1 6.229-1.82 11.281 11.281 0 0 1 6.231 1.818 13.564 13.564 0 0 1 4.514 4.782 1.9 1.9 0 0 1 .2.468 1.893 1.893 0 0 1 .062.484 1.885 1.885 0 0 1-.062.484 1.9 1.9 0 0 1-.2.468 13.565 13.565 0 0 1-4.509 4.782 11.281 11.281 0 0 1-6.236 1.814zm-.002-7.552zm0 5.934a10.3 10.3 0 0 0 5.6-1.6 10.543 10.543 0 0 0 3.9-4.329 10.544 10.544 0 0 0-3.9-4.329 10.3 10.3 0 0 0-5.6-1.6 10.3 10.3 0 0 0-5.6 1.6 10.544 10.544 0 0 0-3.9 4.329 10.543 10.543 0 0 0 3.9 4.329 10.3 10.3 0 0 0 5.6 1.6z"
                                      />
                                      <path
                                        data-name="Rectangle 293"
                                        fill="none"
                                        d="M0 0h26v26H0z"
                                      />
                                    </g>
                                  </svg>
                                </button>
                              </div>
                              {/* edit */}

                              {userRoleId === 1 && (
                                <div style={{ margin: "0 0.5vw" }}>
                                  <button
                                    disabled={true}
                                    style={{
                                      border: "none",

                                      color: "#0066ff",
                                      backgroundColor: "transparent",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleEditService(row["id"])}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 26 26"
                                    >
                                      <g data-name="Group 303">
                                        <path d="M4.099 24a2.027 2.027 0 0 1-1.49-.61 2.027 2.027 0 0 1-.61-1.49V6.352a2.027 2.027 0 0 1 .61-1.49 2.027 2.027 0 0 1 1.49-.61h7.96a.785.785 0 0 1 .653.274.939.939 0 0 1 .218.6.917.917 0 0 1-.227.6.811.811 0 0 1-.662.274H4.099a.342.342 0 0 0-.246.112.342.342 0 0 0-.112.246v15.548a.342.342 0 0 0 .112.246.342.342 0 0 0 .246.112h15.548a.342.342 0 0 0 .246-.112.342.342 0 0 0 .112-.246V13.89a.785.785 0 0 1 .274-.653.939.939 0 0 1 .6-.218.939.939 0 0 1 .6.218.785.785 0 0 1 .274.653v8.015a2.027 2.027 0 0 1-.61 1.49 2.027 2.027 0 0 1-1.49.61zm7.775-9.874zm-2.9 1.854v-2.069a2.062 2.062 0 0 1 .163-.808 2.084 2.084 0 0 1 .449-.674l9.912-9.912a1.7 1.7 0 0 1 .594-.394 1.83 1.83 0 0 1 .659-.124 1.778 1.778 0 0 1 .657.124 1.678 1.678 0 0 1 .574.383l1.459 1.454a1.98 1.98 0 0 1 .388.6 1.713 1.713 0 0 1 .135.661 1.881 1.881 0 0 1-.115.65 1.609 1.609 0 0 1-.385.585l-9.946 9.946a2.209 2.209 0 0 1-.674.458 1.97 1.97 0 0 1-.808.172h-2.013a1.017 1.017 0 0 1-.749-.3 1.017 1.017 0 0 1-.304-.752zM22.239 5.23 20.78 3.738zM10.716 15.287h1.448l7.24-7.24-.724-.724-.775-.746-7.189 7.189zm7.964-7.964-.775-.746.775.746.724.724z" />
                                        <path
                                          data-name="Rectangle 294"
                                          fill="none"
                                          d="M0 0h26v26H0z"
                                        />
                                      </g>
                                    </svg>
                                  </button>
                                </div>
                              )}

                              {/* delete */}

                              {userRoleId === 1 && (
                                <div>
                                  <button
                                    style={{
                                      border: "none",
                                      color: "#0066ff",
                                      backgroundColor: "transparent",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleDeleteService(row["id"])
                                    }
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 26 26"
                                    >
                                      <g data-name="Group 302">
                                        <path
                                          data-name="delete_FILL0_wght300_GRAD0_opsz24 (1)"
                                          d="M6.658 24a2.267 2.267 0 0 1-1.663-.692 2.268 2.268 0 0 1-.692-1.663V5.107h-.326a.945.945 0 0 1-.7-.281.946.946 0 0 1-.281-.7.944.944 0 0 1 .281-.7.946.946 0 0 1 .7-.281h4.886a1.111 1.111 0 0 1 .337-.816 1.111 1.111 0 0 1 .816-.337h5.513a1.111 1.111 0 0 1 .816.337 1.111 1.111 0 0 1 .337.816h4.886a.945.945 0 0 1 .7.281.947.947 0 0 1 .281.7.945.945 0 0 1-.281.7.946.946 0 0 1-.7.281h-.326v16.538a2.268 2.268 0 0 1-.692 1.663 2.267 2.267 0 0 1-1.663.692zM19.287 5.107H6.257v16.538a.39.39 0 0 0 .113.288.39.39 0 0 0 .288.113h12.228a.39.39 0 0 0 .288-.113.39.39 0 0 0 .113-.288zm-8.92 14.333a.944.944 0 0 0 .7-.281.946.946 0 0 0 .281-.7V8.687a.945.945 0 0 0-.281-.7.946.946 0 0 0-.7-.281.945.945 0 0 0-.7.281.946.946 0 0 0-.281.7v9.772a.946.946 0 0 0 .281.7.946.946 0 0 0 .7.281zm4.811 0a.945.945 0 0 0 .7-.281.946.946 0 0 0 .281-.7V8.687a.945.945 0 0 0-.281-.7.946.946 0 0 0-.7-.281.945.945 0 0 0-.7.281.946.946 0 0 0-.281.7v9.772a.945.945 0 0 0 .281.7.946.946 0 0 0 .7.281zM6.257 5.107z"
                                        />
                                        <path
                                          data-name="Rectangle 292"
                                          fill="none"
                                          d="M0 0h26v26H0z"
                                        />
                                      </g>
                                    </svg>
                                  </button>
                                </div>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </Card>
        <DatePickerModal isOpen={isModalOpenDate} onClose={closeModalDate}>
          <div className="modal__popup">
            <div className="date-filter-container">
              <div
                className="date-pickers"
                style={{ display: "flex", gap: "16px" }}
              >
                <DateRangePicker
                  ranges={[selectionRange]}
                  staticRanges={staticRanges}
                  onChange={handleSelect}
                />
              </div>
              <div
                className="action-buttons"
                style={{ marginTop: "16px", textAlign: "right" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApply}
                >
                  Apply
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={closeModalDate}
                  style={{ marginLeft: "8px" }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </DatePickerModal>
        <RejectionModal isOpen={isVisible} onClose={handleToggleVisibility}>
          <div
            className="modal__popup"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <div className="Portal-Login-Form">
              <div className="ValidationModal" style={{ display: "block" }}>
                <div
                  style={{
                    background: "white",
                    padding: "30px",
                    border: "2px solid #333",
                    marginBottom: "20px",
                    fontFamily: "'Arial', sans-serif",
                    color: "#000",
                    maxWidth: "450px",
                    margin: "0 auto",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "25px",
                      borderBottom: "2px solid #333",
                      paddingBottom: "15px",
                    }}
                  >
                    <img
                      src="/logo.png"
                      alt="Logo"
                      style={{ height: "50px" }}
                    />
                    <h1 style={{ fontSize: "20px", fontWeight: "bold" }}>
                      ELEGANCE MAKEUP STUDIO
                    </h1>
                    <div style={{ fontSize: "11px", color: "#555" }}>
                      2nd Floor, Plaza 147, Central Commercial, Bahria Orchard,
                      Lahore
                      <br />
                      Phone: +923345555882 | Email:
                      elegancemakeupstudioo@gmail.com
                    </div>
                  </div>

                  <h2
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      letterSpacing: "2px",
                      marginBottom: "20px",
                    }}
                  >
                    RECEIPT
                  </h2>

                  {/* CUSTOMER INFO */}
                  <div style={{ fontSize: "12px", marginBottom: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Customer:</strong>
                      <span>{eyeData?.name || "-"}</span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Date:</strong>
                      <span>{new Date().toLocaleDateString()}</span>
                    </div>
                  </div>

                  {/* SERVICES TABLE */}
                  <table
                    width="100%"
                    style={{ fontSize: "11px", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr style={{ borderBottom: "1px solid #333" }}>
                        <th align="left">SERVICE</th>
                        <th align="center">QTY</th>
                        <th align="right">BASE</th>
                        <th align="right">TAX</th>
                        <th align="right">TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(eyeData?.servicesData || []).map(
                        (s: any, i: number) => {
                          const price =
                            Number(DecryptData(s.servicePrice)) || 0;
                          const qty = Number(DecryptData(s.quantity)) || 1;
                          const discount = Number(DecryptData(s.discount)) || 0;

                          const total = price * qty - discount;
                          const base = total / 1.08;
                          const tax = total - base;

                          return (
                            <tr
                              key={i}
                              style={{ borderBottom: "1px dotted #ccc" }}
                            >
                              <td>{DecryptData(s.serviceName)}</td>
                              <td align="center">{qty}</td>
                              <td align="right">{base.toFixed(0)}</td>
                              <td align="right">{tax.toFixed(0)}</td>
                              <td align="right">
                                <strong>{total.toFixed(0)}</strong>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>

                  {/* TOTALS (SAFE) */}
                  {(() => {
                    const totals = (eyeData?.servicesData || []).reduce(
                      (acc: any, s: any) => {
                        const price = Number(DecryptData(s.servicePrice)) || 0;
                        const qty = Number(DecryptData(s.quantity)) || 1;
                        const discount = Number(DecryptData(s.discount)) || 0;

                        const total = price * qty - discount;
                        const base = total / 1.08;
                        const tax = total - base;

                        acc.base += base;
                        acc.tax += tax;
                        acc.total += total;
                        return acc;
                      },
                      { base: 0, tax: 0, total: 0 }
                    );

                    return (
                      <div
                        style={{
                          marginTop: "15px",
                          borderTop: "2px solid #333",
                          paddingTop: "10px",
                          fontSize: "13px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Total (Without Tax)</span>
                          <span>{totals.base.toFixed(0)}</span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Total Tax (8%)</span>
                          <span>{totals.tax.toFixed(0)}</span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginTop: "6px",
                          }}
                        >
                          <span>GRAND TOTAL</span>
                          <span>{totals.total.toFixed(0)}</span>
                        </div>
                      </div>
                    );
                  })()}

                  {/* {eyeData?.reason && (
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "10px",
                        color: "#666",
                        fontStyle: "italic",
                      }}
                    >
                      <strong>Discount Reason:</strong> {eyeData.reason}
                    </div>
                  )} */}

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "25px",
                      fontSize: "10px",
                      color: "#666",
                      borderTop: "1px solid #333",
                      paddingTop: "15px",
                    }}
                  >
                    Thank you for choosing Elegance Makeup Studio!
                  </div>
                </div>

                <div
                  className="CloseRejectionModalButton"
                  style={{ justifyContent: "center" }}
                >
                  <button
                    type="button"
                    className="CloseRejectionModal"
                    onClick={handleToggleVisibility}
                  >
                    Close
                  </button>
                  {/* PRINT BUTTON */}
                  <button
                    type="button"
                    className="rejectButtonValidationModal"
                    style={{
                      background: "#719879",
                      cursor: disablePrint ? "progress" : "pointer",
                      padding: "10px 30px",
                    }}
                    disabled={disablePrint}
                    onClick={() => onPrint(eyeData)}
                  >
                    {disablePrint ? "Printing..." : "Confirm & Print"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </RejectionModal>

        <RejectionModal isOpen={isModalOpen} onClose={closeModal}>
          <div className="modal__popup">
            <div className="Portal-Login-Form">
              <div
                className="ValidationModal"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span className="approvalText">
                  Are you sure that you want to delete thatBooking?
                </span>

                <div className="CloseRejectionModalButton">
                  <button
                    type="button"
                    className="CloseRejectionModal"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="rejectButtonValidationModal"
                    onClick={closeModalWithDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </RejectionModal>
      </div>
    </Layout>
  );
}
